module.exports = __webpack_public_path__ + "img/20170704_135648_082.eb86c11d.jpg";